import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

/**
 * Interceptor per gestire l'URL delle API REST
 * Aggiunge il prefisso dell'API REST all'URL della richiesta se non è già un URL assoluto
 *
 * @param req La richiesta HTTP
 * @param next Il gestore della richiesta successivo
 * @returns La risposta HTTP
 */
export const restInterceptor: HttpInterceptorFn = (req, next) => {
  // Evita di modificare richieste già assolute o verso GraphQL
  if (req.url && !/^https?:\/\//i.test(req.url) && !req.url.includes('/graphql')) {
    /** Verifica se la richiesta è per l'API REST UAS altrimenti è una richiesta REST normale */
    if (req.url.startsWith('/uas')) {
      req = req.clone({
        url: `${environment.apiConfig.uasUrl}${req.url.replace(/^\/uas/, '')}`,
      });
      /** Verifica se la richiesta è per l'API REST System altrimenti è una richiesta REST normale */
    } else if (req.url.startsWith('/system')) {
      req = req.clone({
        url: `${environment.apiConfig.systemUrl}${req.url.replace(/^\/system/, '')}`,
      });
      /** Verifica se la richiesta è per l'API REST Z Printer Gateway altrimenti è una richiesta REST normale */
    } else if (req.url.startsWith('/api/printer')) {
      req = req.clone({
        url: `${environment.apiConfig.zPrinterGatewayUrl}${req.url.replace(/^\/api\/printer/, '')}`,
      });
    } else if (req.url.startsWith('/api/health') || req.url.startsWith('/api/settings')) {
      req = req.clone({
        url: `${environment.apiConfig.zPrinterGatewayBaseUrl}${req.url}`,
      });
    } else {
      req = req.clone({
        url: `${environment.apiConfig.restUrl}${req.url}`,
      });
    }
  }

  return next(req);
};
